import type { HistoricalSource } from '../types/contractHistorical';

/** Map every data table column key to historical modal source (direct, calculated, or derived). */
export function columnKeyToHistoricalSource(columnKey: string): HistoricalSource {
  const key = columnKey.trim();
  if (key === 'Volume' || key === 'Total Volume' || key === 'Trade Count') return 'volume';
  if (/^Volume D-\d+$/.test(key)) return 'volume';
  if (key === 'Open Interest') return 'oi';
  if (key === 'Bid Volume' || key === 'Bid' || key === 'Bid Count') return 'bid';
  if (key === 'Ask Volume' || key === 'Ask' || key === 'Ask Count') return 'ask';
  if (key === 'Last') return 'last';
  if (key === 'Mid') return 'mid';
  if (key === 'Strike') return 'mid';
  if (key === 'Delta ( ask - bid )' || key === 'Delta accumelated') return 'delta';
  if (
    key === 'Delta Premium' ||
    key === 'Delta Accumulated Premium' ||
    key === 'Bid Volume Premium' ||
    key === 'Ask Volume Premium' ||
    key === 'Bid Accumulated Premium' ||
    key === 'Ask Accumulated Premium' ||
    key === 'Overall Premium'
  ) {
    return 'premium';
  }
  if (key === 'Delta') return 'delta';
  if (key === 'Gamma') return 'gamma';
  if (key === 'Vanna' || key === 'Charm') return 'theta';
  if (key === 'Implied Volatility' || key === 'Band (IV Indicator)') return 'vega';
  if (key === 'Theta') return 'theta';
  if (key === 'Rho') return 'rho';
  if (key === 'Lambda') return 'lambda';
  if (key === 'Haltz (Volume Concentration)') return 'haltz';
  if (key === 'Zahn (Count Indicator)') return 'zahn';
  if (key === 'Mal (Gamma Indicator)') return 'mal';
  if (key === 'Vol/OI') return 'vol_oi';
  if (key === 'Theoretical Value') return 'theoretical';
  return 'volume';
}
